import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../ReusableComponents/title";
import "../../assets/css/accountmetrics.scss";
import HeadAndDesc from "../ReusableComponents/HeadAndDesc";
import AMDropdown from "../ReusableComponents/AMDropdown";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import BalanceChart from "../Charts/BalanceChart";
import ProfitChart from "../Charts/ProfitChart";
import { dollarUS } from "../../utilities/formatters";
import {
  SetTradesData,
  fetchAccountObjectives,
  saveError,
  setProgramObjectives,
} from "../../store/reducers/dashboardReducer";
import logoutReducer from "../../store/reducers/logout";
import { axiosInstance } from "../../Axios";
import NewCalender from "./NewCalender/NewCalender";
import {
  formatDateInTimeZone,
  formatDateInTimeZoneUTC,
} from "../../utilities/string";
import PnLChart from "./CalendarDetailData/PnLChart/PnLChart";
import TradeStats from "./CalendarDetailData/TradeStats/TradeStats";
import TradeTable from "./CalendarDetailData/TradeTable/TradeTable";
import { ReactComponent as Arrow } from "../../assets/icons/NewIcons/Arrow.svg";
import moment from "moment";
import { ReactComponent as EyeIcon } from "../../assets/icons/NewIcons/eyeIcon.svg";
import { ReactComponent as EyeSlashedIcon } from "../../assets/icons/NewIcons/eyeSlashedIcon.svg";

import { ReactComponent as LeftIcon } from "../../assets/icons/NewIcons/LeftIcon.svg";
import { ReactComponent as RightIcon } from "../../assets/icons/NewIcons/RightIcon.svg";
import DatePicker from "react-datepicker";
import backBtn from "../../assets/icons/UpdatedCheckoutPage/backBtn.svg";

const NumFormatter = (num) => {
  const NumClass = num < 0 ? "Negative" : "Positive";

  return <div className={NumClass}>{Number(num).toFixed(2)}</div>;
};

const StatFormatter = (data) => {
  const Stat = data && data.toLowerCase();

  const classList =
    Stat === "success"
      ? "StatusPassed"
      : Stat === "failed"
      ? "StatusFailed"
      : "StatusInProgress";

  return <div className={`AMStat statusIndicator ${classList}`}>{data}</div>;
};

const ProgramObjectives = ({
  AccountInfo,
  Statistics,
  ProfitHistory,
  DailySummary,
  ProfitChartData,
  DrawDown,
  PerformanceChart,
  ProfitData,
  setRefreshData,
  refreshData,
  Trades,
}) => {
  const metrics = useSelector((state) => state.dashboard);
  const { accountInsights } = useSelector((state) => state.dashboard);
  console.log(AccountInfo, "accountInsightsaccountInsights");

  const [value, setValue] = React.useState("1");
  const [Objectives, setObjectives] = React.useState(false);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  // kanban board data fetch

  const current_account = useSelector((state) => state.user.current_account);
  const idToken = useSelector((state) => state.ACCtoken);
  const [selectedDateValue, setSelectedDateValue] = useState(false);
  const [dateWiseData, setDateWiseData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const breachedAtString =
    (Objectives?.drawdown_result?.breached_at &&
      Objectives?.drawdown_result?.breached_at) ||
    ""; // Default to empty string if not defined

  // Only parse if breachedAtString is not empty
  let breachedAtObject = {};

  if (breachedAtString) {
    try {
      breachedAtObject = JSON.parse(breachedAtString);
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }

  const dummyData = {
    login_id: "137",
    is_active: false,
    password: "password123",
    investor_password: "eWSmk5$3Or",
    name: "Vishal 123",
    start_date: "2024-06-11T00:00:00Z",
    expiry_date: "2024-07-10T00:00:00Z",
    initial_deposit: 0,
    account_balance_equity: {
      balance: 50000,
      equity: 0,
    },
    trading_platform: 1,
    account_metrics: {
      calculated_data: {
        plan_name: "Basic Plan",
        expectancy_ratio: 0,
        avg_lots: 0,
        profit_factor: 0,
        profit: 0,
        average_profit: 0,
        average_loss: 0,
        rrr: 0,
        average_rrr: 0,
        total_trades: 0,
        highest: 0,
        lots: 0,
        absolute_gain: 0,
        monthly_gain: 0,
        daily_gain: 0,
        win_rate: 0,
        lost_trades: 0,
        daily_drawdown: 0,
        max_drawdown: 0,
        starting_balance: 0,
        current_balance: 0,
        consistency: 0,
        worst_trade: 0,
        best_day_percentage: 0,
      },
      data: [],
      day_wise_data: {
        day_stats: [],
      },
      program_objectives: {
        maximum_consistency: 50.5,
        trading_days: 0,
        trading_days_target: 3,
        remaining_trading_days: 3,
        trading_days_status: "In Progress",
        max_loss: 0,
        max_loss_target: 48000,
        max_loss_status: "In Progress",
        max_daily_loss: 0,
        max_daily_loss_status: "Failed",
        max_daily_loss_target: 0,
        remaining_max_loss: 48000,
        remaining_daily_max_loss: 0,
        remaining_profit: 3000,
        profit: 0,
        profit_status: "In Progress",
        profit_target: 3000,
        profit_progress_bar: 0,
        daily_loss_progress_bar: 0,
      },
      get_trading_accounts: {
        realizedDayPnl: 0,
        updatedAt: "2024-07-02T11:29:27.295987+00:00",
        personalDailyLossLimit: null,
        personalDailyLossLimitAction: 0,
        personalDailyProfitTarget: null,
        personalDailyProfitTargetAction: 0,
        totalProfit: 0,
        totalLoss: 0,
        totalTrades: 0,
        dailyTrades: 0,
        isFollower: false,
        isLeader: false,
        openPnl: 0,
        highestBalance: 50000,
        highestUnrealizedBalance: 0,
        highestRealizedBalance: 0,
        templateId: null,
        accountName: "202406294",
        nickname: null,
        userId: 7,
        startingBalance: 50000,
        balance: 50000,
        status: 4,
        marketDataLevel: 0,
        accountId: 137,
        winRate: 0,
        profitAndLoss: 0,
        startDate: "2024-06-29T21:41:38.537183+00:00",
        closedDate: "2024-07-02T11:29:27.295668+00:00",
        dailyLoss: 0,
        maximumLoss: 48000,
        drawDownLimit: 2000,
        maxPositions: 5,
        type: 1,
        startOfDayBalance: 50000,
        combineName: "50K",
        platformId: 0,
        platformAccountId: null,
        platformUserName: null,
        maxMargin: 50000,
        minimumMll: null,
        isSharing: false,
      },
      purchase_price: 79,
    },
    next_payout_date: null,
  };

  const dispatch = useDispatch();
  const fetchTradesData = async () => {
    try {
      // const payload = idToken;
      const { data, status } = await axiosInstance.get(
        `v2/account/datewise-histroy/${current_account}?platform=${AccountInfo.platform}`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          cacheControl: "no-cache",
          pragma: "no-cache",
        }
      );
      if (status === 401) {
        dispatch(logoutReducer());
        return;
      }
      dispatch(SetTradesData(data || []));
    } catch (error) {
      dispatch(saveError(error));
    }
  };
  useEffect(() => {
    AccountInfo?.platform && fetchTradesData();
  }, [current_account, idToken]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [showCalender, setShowCalender] = useState(false);

  const ProfitTargetObj = () => {
    if (Objectives) {
      return (
        <AMDropdown
          head={`Profit ${
            Objectives &&
            Objectives["profit_target"] &&
            dollarUS(Objectives["profit_target"]["target"])
          }`}
          desc={"Profit target"}
          result={
            Objectives &&
            Objectives["profit_target"] &&
            dollarUS(Objectives["profit_target"]["result"].toFixed(2))
          }
          status={
            Objectives &&
            Objectives["profit_target"] &&
            Objectives["profit_target"]["status"]
          }
        />
      );
    }

    return false;
  };

  useEffect(() => {
    return () => {
      setValue("1");
    };
  }, []);

  useEffect(() => {
    if (
      AccountInfo &&
      AccountInfo.daily_max_dd &&
      AccountInfo.challenge &&
      AccountInfo.challenge["Max_Daily_Loss"]
    ) {
      dispatch(
        fetchAccountObjectives(
          AccountInfo.login_id?.replace("#", "%23"),
          AccountInfo.platform
        )
      )
        .then((data) => {
          setObjectives(data);
          dispatch(setProgramObjectives(data));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [AccountInfo, dispatch]);

  const user_profile = useSelector((state) => state.user);
  useEffect(() => {
    if (Object.keys(user_profile).length) {
      if (user_profile.current_account) {
        setValue("1");
      }
    }
  }, [user_profile]);

  const [refreshTimer, setRefreshTimer] = useState(5);

  const handleRefreshData = (id) => {
    if (AccountInfo && AccountInfo.login_id) {
      dispatch(
        fetchAccountObjectives(AccountInfo.login_id, AccountInfo.platform)
      )
        .then((data) => {
          setObjectives(data);
          id && id.classList.remove("refreshIcon");
        })
        .catch((error) => {
          console.log(error);
          id && id.classList.remove("refreshIcon");
        });
    }
  };
  const handleRefreshDataClick = () => {
    const id = document.getElementById("refresh-icon");
    id.classList.add("refreshIcon");

    setTimeout(() => {
      id.classList.remove("refreshIcon");
    }, 3000);
    handleRefreshData(id);
  };

  useEffect(() => {
    let refresh;
    if (refreshTimer < 0) {
      setRefreshTimer(5);
      handleRefreshData();
    }
    if (refreshData) {
      refresh = setInterval(() => {
        setRefreshTimer((prev) => --prev);
      }, 1000);
    } else {
      setRefreshTimer(5);
    }

    return () => {
      clearInterval(refresh);
    };
  }, []);
  const targetDate =
    Objectives &&
    Objectives["drawdown_result"]["max_daily_loss"]["reset_utc_time"];

  const handlePreviousDate = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 1); // Go one day back
      return newDate;
    });
  };

  const handleNextDate = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 1); // Go one day forward
      return newDate;
    });
  };

  // For filter the data according to selected date
  useEffect(() => {
    if (selectedDateValue) {
      window.scroll(0, 0);

      const utcDate = moment(selectedDate)?.format("DD-MM-YYYY");
      const tradeValues =
        Trades &&
        Trades?.filter(
          (item) => formatDateInTimeZoneUTC(item?.date) === utcDate
        );
      setSelectedDateValue(tradeValues);
    }
  }, [selectedDate]);

  // Date Selector For Chart
  const currentDate = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(currentDate.getDate() - 30);

  // Ensure that both startDate and endDate are initialized as Date objects
  const [dateRange, setDateRange] = useState([tenDaysAgo, currentDate]);
  const [startDate, endDate] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(date).toLocaleDateString("en-GB", options); // Format as yyyy-MM-dd
  };
  // Function to convert UTC to local date format (for chart or other purposes)
  const utc_to_eet = (date) => {
    if (date) {
      const EETOffset = 0 * 60; // Adjust as needed for local timezone
      const localTime = new Date(
        new Date(date).getTime() + EETOffset * 60 * 1000
      ); // Ensure it's a valid date object
      return localTime.toISOString();
    }
    return "";
  };

  // Ensure valid Date objects and filter the data based on the selected date range
  const filteredData = useMemo(() => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      // Validate start and end dates
      if (
        !(start instanceof Date && end instanceof Date) ||
        isNaN(start.getTime()) ||
        isNaN(end.getTime())
      ) {
        console.error("Invalid date range provided");
        return [];
      }

      // Normalize dates to start and end of the day
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      // Filter data
      return Array.isArray(PerformanceChart)
        ? PerformanceChart.filter((item) => {
            const itemTime = new Date(item?.time);
            if (isNaN(itemTime.getTime())) {
              console.warn(`Invalid date in PerformanceChart: ${item?.time}`);
              return false;
            }
            return itemTime >= start && itemTime <= end;
          })
        : [];
    }

    // If startDate and endDate are not provided, return all data
    return Array.isArray(PerformanceChart) ? PerformanceChart : [];
  }, [PerformanceChart, startDate, endDate]);

  // Prepare the data for the chart (equity and balance)
  const series = useMemo(() => {
    if (filteredData?.length > 0) {
      const balancedata = filteredData?.map((item) => item.balance);
      const equitydata = filteredData?.map((item) => item.equity);
      return [
        { name: "Equity", data: equitydata },
        { name: "Balance", data: balancedata },
      ];
    }
    return [];
  }, [filteredData]);

  // Prepare the labels for the chart based on filtered data
  const labels = useMemo(() => {
    return filteredData?.map((item) => utc_to_eet(item.time));
  }, [filteredData]);
  const legendData = [
    {
      title: "Balance",
      value: PerformanceChart?.account_balance_equity?.balance,
      color: "#c7f464 ",
    },
    {
      title: "Equity",
      value: PerformanceChart?.account_balance_equity?.balance,
      color: "#4ecdc4",
    },
    {
      title: "Profit target",
      value:
        PerformanceChart?.account_metrics?.get_trading_accounts
          ?.startingBalance +
        PerformanceChart?.account_metrics?.program_objectives?.profit_target,
      color: "#64C144",
    },
    {
      title: "Max loss limit",
      value:
        PerformanceChart?.account_metrics?.get_trading_accounts?.maximumLoss,
      color: "#FD504F",
    },
    {
      title: "Max daily loss",
      value:
        PerformanceChart?.account_metrics?.get_trading_accounts?.maximumLoss,
      color: "#ff154498",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [currentTime, setCurrentTime] = useState(
    String(new Date()).split("GMT")[0].trim()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(String(new Date()).split("GMT")[0].trim());
    }, 5000); // Update time every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const performance_chart = useSelector(
    (state) => state.dashboard?.accountInsights
  );

  const [accountVisible, setAccountVisible] = useState(false);

  return (
    <div className="programObjectivesContent">
      <div className="detailCalData_container">
        {selectedDateValue ? (
          <div className="detailCalData_wrapper">
            <div className="day_wise_data">
              <div className="headerSection">
                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="dateBox">
                    <button onClick={handlePreviousDate}>
                      <LeftIcon />
                    </button>
                    <p>{moment(selectedDate).format("dddd, MMMM YYYY")}</p>
                    <button onClick={handleNextDate}>
                      <RightIcon />
                    </button>
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    className="backBtnContainer"
                    onClick={() => setSelectedDateValue(false)}
                  >
                    <img
                      style={{ width: "20px" }}
                      src={backBtn}
                      alt="backBtn"
                    />
                    Back
                  </div>
                </div>

                {/* <div className="noteBtn">
                  <button>View Note</button>
                </div> */}
              </div>
              <div className="chartData">
                <PnLChart selectedDateValue={selectedDateValue} />
                <TradeStats selectedDateValue={selectedDateValue} />
              </div>
              <div className="tableData">
                <TradeTable selectedDateValue={selectedDateValue} />
              </div>
            </div>

            <div className="statsTradeData">
              <Grid item md={5} xs={12} className="statisticsSection">
                <Grid container className="StatisticsBox d-grid mbb-20">
                  <Grid className="mtt-20 AMStatBox">
                    <Grid
                      item
                      className="StatisticAM  mbb-20"
                      xs={6}
                      justifyContent="space-between"
                    >
                      <div className="firstBoxData">
                        <HeadAndDesc
                          className="hover-chart-text"
                          HeadTitle="Equity"
                          SubTitle={
                            AccountInfo && AccountInfo?.equity
                              ? dollarUS(AccountInfo?.equity)
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          className="hover-chart-text"
                          HeadTitle="Balance"
                          SubTitle={
                            AccountInfo && AccountInfo?.balance
                              ? dollarUS(AccountInfo?.balance)
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="No. of trades"
                          SubTitle={(Statistics && Statistics?.trades) || 0}
                        />{" "}
                        <HeadAndDesc
                          HeadTitle="Lots"
                          SubTitle={
                            Statistics && Statistics?.lots
                              ? Statistics?.lots?.toFixed(2)
                              : 0
                          }
                        />
                      </div>

                      <div className="secondBoxData">
                        {" "}
                        <HeadAndDesc
                          HeadTitle="Win rate"
                          SubTitle={
                            Statistics && Statistics?.win_ratio
                              ? `${Statistics?.win_ratio?.toFixed(2)} %`
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Highest"
                          SubTitle={
                            Statistics && Statistics?.highest
                              ? `${Statistics?.highest?.toFixed(2)}`
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Average profit"
                          SubTitle={
                            Statistics && Statistics?.average_profit
                              ? dollarUS(
                                  Number(Statistics?.average_profit)?.toFixed(2)
                                )
                              : "$0"
                          }
                          SubTitleClass="DescPositive"
                        />
                        <HeadAndDesc
                          HeadTitle="Average loss"
                          SubTitle={
                            Statistics && Statistics?.average_loss
                              ? dollarUS(
                                  Number(Statistics?.average_loss)?.toFixed(2)
                                )
                              : "$0"
                          }
                          SubTitleClass="DescNegative"
                        />
                      </div>

                      <div className="thirdBoxData">
                        {" "}
                        <HeadAndDesc
                          HeadTitle="Average RRR"
                          SubTitle={
                            Statistics && Statistics["rrr "]
                              ? Number(Statistics["rrr "])?.toFixed(2)
                              : 0
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Expectancy"
                          SubTitle={
                            Statistics && Statistics?.expectancy_ratio
                              ? Statistics?.expectancy_ratio?.toFixed(2)
                              : 0
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Profit Factor"
                          SubTitle={
                            Statistics && Statistics?.profit_factor
                              ? Statistics?.profit_factor?.toFixed(2)
                              : 0
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Interest"
                          SubTitle={
                            Statistics && Statistics?.interest
                              ? Statistics?.interest?.toFixed(2)
                              : 0
                          }
                        />
                      </div>
                    </Grid>

                    <Grid className="mtt-20 StatsTime" alignItems={"center"}>
                      <HeadAndDesc
                        width="100%"
                        HeadTitle="Timezone :"
                        SubTitle={String(new Date())?.split(" ")[5]}
                        HeadAndSubClassName="Timezone"
                      />
                      <HeadAndDesc
                        width="100%"
                        HeadTitle="Last Updated :"
                        SubTitle={currentTime}
                        HeadAndSubClassName="d-flex lastUpdated"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                className="CalDetailTradingBOx TradingObjBox d-grid mbb-20"
              >
                <h5 className="title_section">Trading Objective</h5>
                <Grid
                  className="TOBox mtt-20"
                  gap="10px"
                  display="flex"
                  flexDirection="column"
                >
                  {AccountInfo && AccountInfo.status === "Funded" ? (
                    <AMDropdown
                      head={`Withdrawal Dates`}
                      desc={"Withdrawal dates"}
                      result={false}
                      status={
                        Objectives &&
                        Objectives["payout_dates"] &&
                        `${Objectives.payout_dates[0]} & ${Objectives.payout_dates[1]}`
                      }
                    />
                  ) : Objectives ? (
                    <AMDropdown
                      head={`Minimum days - ${
                        Objectives && Objectives["trading_days"]
                          ? Objectives["trading_days"]["target"]
                          : ""
                      }`}
                      desc={"Minimum trading days"}
                      result={
                        Objectives && Objectives["trading_days"]
                          ? Objectives["trading_days"]["result"]
                          : ""
                      }
                      status={
                        Objectives && Objectives["trading_days"]
                          ? Objectives["trading_days"]["status"]
                          : ""
                      }
                    />
                  ) : (
                    false
                  )}
                  {/* <ProfitTargetObj /> */}
                  {Objectives ? (
                    <React.Fragment>
                      <AMDropdown
                        head={`Max Loss ${
                          Objectives &&
                          Objectives["drawdown_result"] &&
                          dollarUS(
                            Objectives["drawdown_result"]["max_loss"]["target"]
                          )
                        }`}
                        desc={"Max Loss"}
                        result={
                          Objectives &&
                          Objectives["drawdown_result"] &&
                          dollarUS(
                            Objectives["drawdown_result"]["max_loss"][
                              "result"
                            ].toFixed(2)
                          )
                        }
                        status={
                          Objectives &&
                          Objectives["drawdown_result"] &&
                          Objectives["drawdown_result"]["max_loss"]["status"]
                        }
                      />
                      <AMDropdown
                        targetValue={
                          Objectives &&
                          Objectives["drawdown_result"] &&
                          dollarUS(
                            Objectives["drawdown_result"]["max_daily_loss"][
                              "target"
                            ]
                          )
                        }
                        head={`Max Daily Loss ${
                          Objectives &&
                          Objectives["drawdown_result"] &&
                          dollarUS(
                            Objectives["drawdown_result"]["max_daily_loss"][
                              "target"
                            ]
                          )
                        }`}
                        desc={"Max Daily Loss"}
                        result={
                          Objectives &&
                          Objectives["drawdown_result"] &&
                          dollarUS(
                            Objectives["drawdown_result"]["max_daily_loss"][
                              "result"
                            ].toFixed(2)
                          )
                        }
                        status={
                          Objectives &&
                          Objectives["drawdown_result"]["max_daily_loss"][
                            "status"
                          ]
                        }
                        remaining={
                          Objectives &&
                          String(
                            Objectives["drawdown_result"]["max_daily_loss"][
                              "status"
                            ]
                          ).toLowerCase() === "failed"
                            ? false
                            : Number(
                                Objectives["drawdown_result"]["max_daily_loss"][
                                  "remaining"
                                ]
                              ).toFixed(2)
                        }
                        targetDate={targetDate}
                      />
                    </React.Fragment>
                  ) : (
                    false
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        ) : (
          <>
            {" "}
            <Grid
              container
              className="AMStatsBox mbb-20 AMStatsBoxContainer"
              justifyContent={"space-between"}
              gap={"20px"}
              marginTop={{ xs: "-30px" }}
              xs={12}
            >
              <Grid
                item
                className="statsContainer"
                textAlign="center"
                md={true}
                xs={true}
              >
                <div className="StatsHead mbb-10">Start Date</div>
                <div className="StatsSub">
                  {AccountInfo && formatDate(AccountInfo.start_date)}
                </div>
              </Grid>
              <Grid
                item
                className="statsContainer"
                textAlign="center"
                md={true}
                xs={true}
              >
                <div className="StatsHead mbb-10">Account Type</div>
                <div className="StatsSub">
                  {metrics?.AccDetails?.challenge?.name}
                </div>
              </Grid>
              <Grid
                item
                className="statsContainer"
                textAlign="center"
                md={true}
                xs={true}
              >
                <div className="StatsHead mbb-10">Account Stage </div>
                <div className="StatsSub">
                  {(metrics?.AccDetails?.is_competition
                    ? "Competition"
                    : metrics?.AccDetails?.status?.replace(
                        "Funded",
                        "Qualified"
                      )) + ` (Steps ${metrics?.AccDetails?.challenge?.steps})`}
                </div>
              </Grid>
              <Grid
                item
                className="statsContainer"
                textAlign="center"
                md={true}
                xs={true}
              >
                <div className="StatsHead mbb-10">Account Size</div>
                <div className="StatsSub">
                  {AccountInfo &&
                  AccountInfo.challenge &&
                  AccountInfo.challenge.account_balance
                    ? dollarUS(AccountInfo.challenge.account_balance)
                    : 0}
                </div>
              </Grid>
              <Grid
                item
                className="statsContainer"
                textAlign="center"
                md={true}
                xs={true}
              >
                <div className="StatsHead mbb-10">Login Id</div>
                <div className="StatsSub loginIdDiv">
                  {/* {accountVisible
                    ? AccountInfo && AccountInfo && AccountInfo?.login_id
                      ?  */}
                  {AccountInfo?.login_id}
                  {/* : 0
                    : "*".repeat(AccountInfo?.login_id?.length || 0)} */}

                  {/* <button onClick={() => setAccountVisible(!accountVisible)}>
                    {accountVisible ? <EyeIcon /> : <EyeSlashedIcon />}
                  </button> */}
                </div>
              </Grid>
              {/* <Grid item textAlign="center" md={2} xs={2}>
          <div className="StatsHead mbb-10">Stage</div>
          <div className="StatsSub">
            {StatFormatter(
              AccountInfo &&
                ((AccountInfo.is_competition && "Competition") ||
                  AccountInfo.status)
            )}
          </div>
        </Grid> */}
              <Grid
                item
                className={`statsContainer ${
                  AccountInfo?.progress === "Failed"
                    ? "failedStatusContainer"
                    : ""
                }`}
                textAlign="center"
                md={true}
                xs={true}
              >
                <div className="StatsHead mbb-10">Status</div>
                <div className="StatsSub statusBox">
                  {StatFormatter(AccountInfo && AccountInfo.progress)}
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="ProgramObjBox">
              <Grid item md={7} xs={12} className=" tradingObjectiveSection">
                <div className="chartContainer">
                  <div className="charts_header">
                    <h3>Trading Objectives</h3>
                    <div className="date_selector">
                      <DatePicker
                        className="date_picker_div"
                        selectsRange
                        startDate={startDate}
                        maxDate={new Date()}
                        endDate={endDate}
                        onChange={(update) => setDateRange(update)}
                        isClearable={true}
                        dateFormat="yyyy-MM-dd"
                        value={`${formatDate(startDate)} - ${formatDate(
                          endDate
                        )}`}
                      />
                    </div>
                  </div>

                  <Box
                    className="ContainerTab"
                    md={12}
                    sx={{ width: "100%", height: "360px" }}
                  >
                    <TabContext value={value}>
                      <Box
                        className="SubTab"
                        sx={{ borderBottom: 1, borderColor: "divider" }}
                      >
                        <TabList
                          onChange={handleChange}
                          aria-label="lab API tabs example"
                        >
                          {/* <Tab
                      className="ContainertabName"
                      label="Growth"
                      value="1"
                    /> */}
                          <Tab
                            className="ContainertabName"
                            label="Balance"
                            value="1"
                          />
                          <Tab
                            className="ContainertabName"
                            label="Profit"
                            value="2"
                          />
                          {/* <Tab
                            className="ContainertabName"
                            label="Drawdown"
                            value="3"
                          /> */}
                        </TabList>
                        {value === "1" && (
                          <div className="chart-legend">
                            {legendData.map((item, index) => (
                              <div className="legend" key={index}>
                                <div>
                                  <span
                                    style={{ background: item.color }}
                                    className="circle"
                                  ></span>
                                  <p className="title">{item.title}</p>
                                </div>
                                {/* <p
                                className={
                                  item?.value > 0
                                    ? "positive_value"
                                    : "navative_value"
                                }
                              >
                                {FormatUSD(item.value)}
                              </p> */}
                              </div>
                            ))}
                          </div>
                        )}
                      </Box>
                      {/* <TabPanel className="ContainerTabpanel" value="1">
                  <GrowthChart />
                </TabPanel> */}
                      <TabPanel className="ContainerTabpanel" value="1">
                        {/* <DateSelector PerformanceChart={PerformanceChart} /> */}
                        <BalanceChart
                          balance_chart={filteredData}
                          profit={
                            Number(Objectives?.profit_target?.target) +
                            Number(AccountInfo?.challenge?.account_balance)
                          }
                          maxLoss={
                            Number(
                              AccountInfo?.challenge?.account_balance || 0
                            ) -
                            Number(
                              Objectives?.drawdown_result?.max_loss?.target > 0
                                ? Objectives?.drawdown_result?.max_loss?.target
                                : Objectives?.drawdown_result?.mll?.target || 0
                            )
                          }
                          accountType={
                            Objectives?.drawdown_result?.account_type
                          }
                          maxDailyLoss={
                            Number(
                              AccountInfo?.challenge?.account_balance || 0
                            ) -
                            Number(
                              Objectives?.drawdown_result?.max_daily_loss
                                ?.target
                            )
                          }
                        />
                      </TabPanel>
                      <TabPanel className="ContainerTabpanel" value="2">
                        <ProfitChart
                          data={ProfitHistory && ProfitHistory}
                          ProfitChartData={ProfitChartData && ProfitChartData}
                          ProfitData={ProfitData}
                        />
                      </TabPanel>
                      {/* <TabPanel className="ContainerTabpanel" value="3">
                        <DrawdownChart DrawDownData={DrawDown} />
                      </TabPanel> */}
                    </TabContext>
                  </Box>
                </div>
                <Grid container className="TradingObjBox d-grid mbb-20">
                  <Title StyleName="title_section" six>
                    Trading Objective
                  </Title>
                  <Grid
                    className="TOBox mtt-20"
                    gap="10px"
                    display="flex"
                    flexDirection="column"
                  >
                    {/* Profit Target */}
                    {Objectives?.profit_target?.target > 0 &&
                      !AccountInfo?.is_competition && (
                        <AMDropdown
                          head="Profit"
                          desc="Profit"
                          result={
                            Objectives.profit_target.result?.toFixed(2) || ""
                          }
                          status={Objectives.profit_target.status || ""}
                          targetValue={dollarUS(
                            Objectives.profit_target.target || 0
                          )}
                          remaining={
                            String(
                              Objectives.profit_target.status || ""
                            ).toLowerCase() === "failed"
                              ? false
                              : (
                                  Number(Objectives.profit_target.target || 0) -
                                  Number(Objectives.profit_target.result || 0)
                                ).toFixed(2)
                          }
                        />
                      )}

                    {/* Withdrawal Dates or Minimum Days */}
                    {AccountInfo?.status === "Funded" &&
                    Objectives?.payout_dates ? (
                      <>
                        {Objectives.payout_dates[0] &&
                          Objectives.payout_dates[1] && (
                            <AMDropdown
                              head="Withdrawal Dates"
                              desc="Withdrawal dates"
                              result={false}
                              status={
                                Objectives?.payout_dates
                                  ? `${Objectives.payout_dates[0] || ""}${
                                      Objectives.payout_dates[1] !== undefined
                                        ? " & " + Objectives.payout_dates[1]
                                        : ""
                                    }`
                                  : ""
                              }
                            />
                          )}
                      </>
                    ) : (
                      Objectives?.trading_days?.target > 0 &&
                      AccountInfo?.status !== "Funded" &&
                      !AccountInfo?.is_competition && (
                        <AMDropdown
                          head={`Minimum days - ${
                            Objectives.trading_days.target || ""
                          }`}
                          desc="Minimum trading days"
                          result={Objectives.trading_days.result || ""}
                          status={Objectives.trading_days.status || ""}
                        />
                      )
                    )}

                    {/* Drawdown Objectives */}
                    {Objectives?.drawdown_result && (
                      <>
                        {Objectives?.drawdown_result?.max_loss?.target > 0 && (
                          <AMDropdown
                            head={`Max Loss ${dollarUS(
                              Objectives.drawdown_result.max_loss?.target || 0
                            )}`}
                            desc="Max Loss"
                            result={dollarUS(
                              Objectives.drawdown_result.max_loss?.result?.toFixed(
                                2
                              ) || 0
                            )}
                            status={
                              Objectives.drawdown_result.max_loss?.status || ""
                            }
                          />
                        )}
                        {Objectives?.drawdown_result?.max_daily_loss?.target >
                          0 && (
                          <AMDropdown
                            head={`Max Daily Loss ${dollarUS(
                              Objectives.drawdown_result.max_daily_loss
                                ?.target || 0
                            )}`}
                            desc="Max Daily Loss"
                            result={dollarUS(
                              Objectives.drawdown_result.max_daily_loss?.result?.toFixed(
                                2
                              ) || 0
                            )}
                            status={
                              Objectives.drawdown_result.max_daily_loss
                                ?.status || ""
                            }
                            targetValue={dollarUS(
                              Objectives.drawdown_result.max_daily_loss
                                ?.target || 0
                            )}
                            remaining={
                              String(
                                Objectives.drawdown_result.max_daily_loss
                                  ?.status || ""
                              ).toLowerCase() === "failed"
                                ? false
                                : Number(
                                    Objectives.drawdown_result.max_daily_loss
                                      ?.remaining || 0
                                  ).toFixed(2)
                            }
                            targetDate={targetDate}
                          />
                        )}
                      </>
                    )}

                    {Objectives?.drawdown_result?.mll?.target > 0 && (
                      <AMDropdown
                        head={`Max loss limit - ${
                          (Objectives.drawdown_result?.mll?.target &&
                            dollarUS(
                              Objectives.drawdown_result?.mll?.target
                            )) ||
                          ""
                        }`}
                        desc="MLL"
                        result={
                          (Objectives.drawdown_result?.mll.result &&
                            dollarUS(Objectives.drawdown_result?.mll.result)) ||
                          "0"
                        }
                        status={Objectives.drawdown_result?.mll.status || ""}
                      />
                    )}

                    {Objectives?.consistency?.target > 0 && (
                      <AMDropdown
                        head={`Consistency - ${
                          Objectives.consistency?.target || ""
                        }`}
                        desc="Consistency"
                        result={Objectives.consistency.result || "0"}
                        status={Objectives.consistency.status || ""}
                        consistency={
                          Objectives.consistency
                        }
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={5} xs={12} className="statisticsSection">
                {" "}
                <Grid container className="StatisticsBox d-grid mbb-20">
                  {/* <Title six>Statistic</Title> */}
                  <div>
                    <Grid className="mtt-20 AMStatBox inner_Box">
                      <Grid
                        item
                        className="StatisticAM  mbb-20"
                        xs={6}
                        justifyContent="space-between"
                      >
                        <HeadAndDesc
                          className="hover-chart-text"
                          HeadTitle="Equity"
                          SubTitle={
                            AccountInfo && AccountInfo.equity
                              ? dollarUS(AccountInfo.equity)
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          className="hover-chart-text"
                          HeadTitle="Balance"
                          SubTitle={
                            AccountInfo && AccountInfo.balance
                              ? dollarUS(AccountInfo.balance)
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="No. of trades"
                          SubTitle={
                            (accountInsights?.total_trades &&
                              accountInsights?.total_trades) ||
                            0
                          }
                        />{" "}
                        <HeadAndDesc
                          HeadTitle="Lots"
                          SubTitle={
                            accountInsights && accountInsights.lots
                              ? accountInsights.lots.toFixed(2)
                              : 0
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Win rate"
                          SubTitle={
                            Statistics && Statistics.win_ratio
                              ? `${Statistics.win_ratio.toFixed(2)} %`
                              : "0 %"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Best trade"
                          SubTitle={
                            Statistics && Statistics.highest
                              ? dollarUS(Number(Statistics.highest).toFixed(2))
                              : "$0"
                          }
                        />
                        {/* <HeadAndDesc
                    HeadTitle="Average Lots"
                    SubTitle={
                      Statistics && Statistics.avg_lots
                        ? Statistics.avg_lots.toFixed(2)
                        : 0
                    }
                  /> */}
                      </Grid>
                      <Grid
                        item
                        className="StatisticAM  gapp-10 mbb-20"
                        xs={6}
                        justifyContent="space-between"
                      >
                        {" "}
                        <HeadAndDesc
                          HeadTitle="Average profit"
                          SubTitle={
                            Statistics && Statistics.average_profit
                              ? dollarUS(
                                  Number(Statistics.average_profit).toFixed(2)
                                )
                              : "$0"
                          }
                          SubTitleClass="DescPositive"
                        />
                        {/* <HeadAndDesc
                    HeadTitle="Largest profit"
                    SubTitle={
                      (Statistics && dollarUS(Statistics.highest)) || "$0"
                    }
                  /> */}
                        <HeadAndDesc
                          HeadTitle="Average loss"
                          SubTitle={
                            Statistics && Statistics.average_loss
                              ? dollarUS(
                                  Number(Statistics.average_loss).toFixed(2)
                                )
                              : "$0"
                          }
                          SubTitleClass="DescNegative"
                        />
                        <HeadAndDesc
                          HeadTitle="Average RRR"
                          SubTitle={
                            Statistics && Statistics["rrr "]
                              ? Number(Statistics["rrr "]).toFixed(2)
                              : 0
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Expectancy"
                          SubTitle={
                            Statistics && Statistics.expectancy_ratio
                              ? dollarUS(
                                  Number(Statistics.expectancy_ratio).toFixed(2)
                                )
                              : "$0"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Profit factor"
                          SubTitle={
                            Statistics && Statistics.profit_factor
                              ? dollarUS(
                                  Number(Statistics.profit_factor).toFixed(2)
                                )
                              : "$0"
                          }
                        />
                        <HeadAndDesc HeadTitle="Interest" SubTitle={"NA"} />
                        {/* <HeadAndDesc
                    HeadTitle="Martingale Status"
                    SubTitle={
                      Objectives
                        ? StatFormatter(
                            String(Objectives.martingale.status).toLowerCase()
                          )
                        : false
                    }
                  /> */}
                        {/* <HeadAndDesc
                    HeadTitle="Martingale Count"
                    SubTitle={
                      Objectives
                        ? Objectives.martingale.martingale_count
                        : false
                    }
                  /> */}
                        {/* <HeadAndDesc
                    HeadTitle=""
                    SubTitle={
                      DailySummary && DailySummary["Expectancy Ratio"]
                        ? Number(DailySummary["Expectancy Ratio"])
                            .toFixed(2)
                            .split("-")
                            .join("")
                        : false
                    }
                  />
                  <HeadAndDesc HeadTitle="" SubTitle={""} />
                  <HeadAndDesc HeadTitle="" SubTitle="" /> */}
                      </Grid>
                      <Grid
                        item
                        className="StatisticAM  gapp-10 mbb-20"
                        xs={6}
                        justifyContent="space-between"
                        mt={2.5}
                      >
                        <HeadAndDesc
                          HeadTitle="Rollover Equity"
                          SubTitle={dollarUS(
                            Objectives?.drawdown_result?.eod_data?.equity
                          )}
                        />
                        <HeadAndDesc
                          HeadTitle="Rollover Balance"
                          SubTitle={dollarUS(
                            Objectives?.drawdown_result?.eod_data?.balance
                          )}
                        />
                        <HeadAndDesc
                          HeadTitle="Breached at"
                          SubTitle={
                            breachedAtObject?.time ? (
                              <>
                                {/* Date */}
                                <div>
                                  {moment(breachedAtObject?.time).format(
                                    "DD-MM-YYYY"
                                  )}
                                </div>

                                {/* Time */}
                                <div>
                                  {moment(breachedAtObject?.time).format(
                                    "hh:mm:ss"
                                  )}
                                </div>
                              </>
                            ) : (
                              "NA"
                            )
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Breached balance"
                          SubTitle={
                            (breachedAtObject?.balance &&
                              dollarUS(breachedAtObject?.balance)) ||
                            "NA"
                          }
                        />
                        <HeadAndDesc
                          HeadTitle="Breached equity"
                          SubTitle={
                            (breachedAtObject?.equity &&
                              dollarUS(breachedAtObject?.equity)) ||
                            "NA"
                          }
                        />
                        {/* <HeadAndDesc
                          HeadTitle="End Date"
                          SubTitle={
                            AccountInfo &&
                            Object.keys(AccountInfo).length &&
                            AccountInfo.expiry_date
                              ? formatDate(AccountInfo.expiry_date)
                              : "Ongoing"
                          }
                        /> */}
                        <HeadAndDesc
                          HeadTitle="End Date"
                          SubTitle={
                            breachedAtObject?.time ? (
                              <>
                                {/* Date */}
                                <div>
                                  {moment(breachedAtObject?.time).format(
                                    "DD-MM-YYYY"
                                  )}
                                </div>

                                {/* Time */}
                                <div>
                                  {moment(breachedAtObject?.time).format(
                                    "hh:mm:ss"
                                  )}
                                </div>
                              </>
                            ) : (
                              "NA"
                            )
                          }
                        />
                        {Objectives?.drawdown_result?.mll.target > 0 && (
                          <HeadAndDesc
                            HeadTitle="High-water mark"
                            SubTitle={
                              Objectives?.drawdown_result?.mll
                                .highest_balance_watermark
                            }
                          />
                        )}
                      </Grid>
                      {/* <img src={LineImg} alt="" /> */}
                      <Grid className="mtt-20 StatsTime" alignItems={"center"}>
                        {/*<HeadAndDesc
                    HeadTitle="Timezone :"
                    SubTitle="GMT+0"
                    HeadAndSubClassName="d-flex"
                  />*/}
                        <HeadAndDesc
                          width="100%"
                          HeadTitle="Timezone :"
                          SubTitle={String(new Date()).split(" ")[5]}
                          HeadAndSubClassName="Timezone"
                        />
                        <HeadAndDesc
                          width="100%"
                          HeadTitle="Last Updated :"
                          SubTitle={String(new Date()).split("GMT")[0].trim()}
                          HeadAndSubClassName="d-flex lastUpdated"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                {/* <Grid container className="DailySummeryBox d-block mbb-20">
            <Title six>Daily Summary</Title>
            <Grid className="mtt-20 d-flex" flexWrap={"nowrap"}>
              <Grid item xs={12} className="d-grid gapp-10">
                <HeadAndDesc
                  HeadTitle="Gain"
                  SubTitle={
                    Statistics &&
                    Statistics.profit &&
                    NumFormatter(Statistics.profit)
                  }

                  // SubTitleClass="DescPositive"
                />
                <HeadAndDesc
                  HeadTitle="Daily"
                  // SubTitle={
                  //   Statistics && Statistics.daily_gain
                  //     ? Statistics.daily_gain
                  //       .reduce((a, b) => a + b, 0)
                  //       .toFixed(2)
                  //     : false
                  // }
                  SubTitle={
                    Statistics &&
                    Statistics.profit &&
                    Statistics.daily_gain.toFixed(2)
                  }
                />
                <HeadAndDesc
                  HeadTitle="Leverage"
                  SubTitle={
                    AccountInfo &&
                    AccountInfo.challenge &&
                    AccountInfo.challenge.Leverage
                      ? AccountInfo.challenge.Leverage
                      : false
                  }
                />
                <HeadAndDesc
                  HeadTitle="Abs Gain"
                  SubTitle={
                    Statistics && Statistics.absolute_gain
                    && (Number(Statistics.absolute_gain)).toFixed(2)
                  }
                  SubTitle={
                    Statistics &&
                    Statistics.absolute_gain &&
                    NumFormatter(Number(Statistics.absolute_gain).toFixed(2))
                  }
                  SubTitleClass="DescPositive"
                />
                <HeadAndDesc
                  HeadTitle="Monthly"
                  SubTitle={
                    Statistics && Number(Statistics.monthly_gain).toFixed(2)
                  }
                />
                <HeadAndDesc
                  HeadTitle="Drawdown"
                  SubTitle={
                    Statistics && Number(Statistics.draw_down).toFixed(2)
                  }
                />
              </Grid>
            </Grid>
          </Grid> */}
              </Grid>
            </Grid>
          </>
        )}
      </div>

      {/* <div className="calender_show_less" style={{ marginTop: "24px" }}>
        <div className="calender_button_line"></div>
        <button
          className={`${showCalender ? "showCalender_arrow" : ""}`}
          onClick={() => setShowCalender(!showCalender)}
        >
          {showCalender ? "Show Less" : "Show More"} <Arrow />
        </button>
        <div className="calender_button_line"></div>
      </div> */}

      <div
        className="main_calendar_container"
        // style={{
        //   display: "grid",
        //   gap: "20px",
        //   gridTemplateColumns: selectedDateValue && "65% 33%",
        // }}

        style={{ marginTop: "24px" }}
      >
        <NewCalender
          data={Trades || []}
          setSelectedDateValue={setSelectedDateValue}
          selectedDateValue={selectedDateValue}
          setDateWiseData={setDateWiseData}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />

        {/* <KabanBoard /> */}

        {/* {selectedDateValue && (
          <div className="selected_trade_con">
            <div className="selected_trade_con_header">
              <h4>
                <span>
                  {selectedDateValue[0]?.createdAt
                    ? formatDateInTimeZone(
                        selectedDateValue[0]?.createdAt,
                        "DD-MM-YYYY (dddd)"
                      )
                    : "No transaction on this date"}
                </span>
              </h4>
              <div
                onClick={() => setSelectedDateValue(false)}
                style={{ cursor: "pointer" }}
              >
                X
              </div>
            </div>

            <div className="profit_loss_info">
              {selectedDateValue?.map((trade) => {
                return (
                  <div>
                    <div
                      className={
                        trade.profit < 0
                          ? `profit_dot`
                          : trade.profit === 0
                          ? `no_p&l`
                          : `loss_dot`
                      }
                    ></div>
                    <p>
                      {trade.profit < 0
                        ? `Loss of ${FormatUSD(trade?.profit || 0)}`
                        : trade.profit === 0
                        ? `No profit/loss - ${FormatUSD(trade?.profit || 0)}`
                        : `Profit of ${FormatUSD(trade?.profit || 0)}`}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ProgramObjectives;
